import React from "react";

import { Box, Typography, Button } from "@mui/material";
import Modal from "@mui/material/Modal";
import { makeStyles, withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

type ModalProps = {
  visibility: boolean;
  onClose: () => void;
  handleUnsend: () => void;
};
const useStyles = makeStyles()((theme) => ({
  root: {
    overflowY: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
  },
  modalBody: {
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(24, 24),
    backgroundColor: colors.white,
    overflowY: "auto",
    width: "470px",
  },
  content: {
    padding: "40px",
  },
  header: {
    fontSize: "20px",
    fontWeight: 700,
    marginBottom: "20px",
  },
  message: {
    fontSize: "16px",
    fontWeight: 600,
    marginBottom: "20px",
    textAlign: "center",
  },
}));

const StyledCancelButton = withStyles(Button, {
  root: {
    color: "#FF6262",
    border: "2px solid #FF6262",
    marginRight: 8,
    "&:hover": {
      color: "#FF6262",
      border: "2px solid #FF6262",
    },
  },
});

const UnsendFormModal: React.FC<ModalProps> = ({
  visibility,
  onClose,
  handleUnsend,
}) => {
  const { classes } = useStyles();
  return (
    <>
      <Modal open={visibility} onClose={onClose} className={classes.root}>
        <Box className={classes.modalBody}>
          <div>
            <Box className={classes.content}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography className={classes.header}>Unsend Form?</Typography>
              </Box>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography className={classes.message}>
                  Are you sure you want to unsend this form?
                </Typography>
              </Box>
              <Box display="flex" justifyContent="center" alignItems="center">
                <StyledCancelButton variant="outlined" onClick={handleUnsend}>
                  Unsend form
                </StyledCancelButton>
                <Button color="primary" onClick={onClose}>
                  Continue Working
                </Button>
              </Box>
            </Box>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default UnsendFormModal;
